import { type DemoFormInput } from '~/components/Modals/demoFormValidation';

/**
 * Maps in-app demo form values to Default `submitForm` response keys.
 *
 * Pending: align keys with Forms → Edit Form → field mapping in the new workspace
 * (Install tab sample is the source of truth). Confirm `company_size` and whether
 * lead_source fields are mapped or metadata-only.
 */
export const mapDemoFormValuesToDefaultResponses = (
  values: DemoFormInput,
): Record<string, string | number | boolean> => ({
  email: values.email,
  first_name: values.firstName,
  last_name: values.lastName,
  company_size: values.company_size,
  phone: values.phone,
  message: values.message,
  lead_source: 'Web (demo request)',
  lead_source_detail: 'Web form - In-app',
});
